import { createContext } from 'react';
import { PromiseClient } from 'hub-http/adapters/promiseClient';

import http from 'hub-http/clients/apiClient';

/**
 * Context to allow consumers to provide their own HTTP client to components here.
 * Original use case was for HubSpot's Gmail extension, which cannot make calls
 * in the page context (CORS), and needs to provide a client from their service worker.
 * @example
 * import { HttpClientContext } from 'content-assistance-lib/api/HttpClientContext';
 *
 * <HttpClientContext.Provider value={http}>
 *   { content }
 * </HttpClientContext.Provider>
 *
 * Consumption:
 * import { useHttpClient } from 'content-assistance-lib/hooks/useHttpClient';
 *
 * const http = useHttpClient();
 * http now uses the provided client, or by default, `apiClient` from hub-http
 */
export const HttpClientContext = createContext<PromiseClient>(http);
